(() => {
  const root = document.querySelector('[data-tf-profile]'); if (!root) return;
  const panels = [...root.querySelectorAll('[data-tf-profile-panel]')];
  function show() {
    const requested = location.hash.slice(1) || 'profile';
    const key = panels.some(panel => panel.id === requested) ? requested : 'profile';
    panels.forEach(panel => panel.hidden = panel.id !== key);
    root.querySelectorAll('[data-tf-profile-link]').forEach(link => {
      if (link.dataset.tfProfileLink === key) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
    });
  }
  window.addEventListener('hashchange', show); show();
  // Keep the profile identity visible when opening a direct referral link.
  if (location.hash === '#referral') {
    const revealReferral = () => {
      const headerBottom = Math.max(0, document.querySelector('header')?.getBoundingClientRect().bottom || 0);
      window.scrollTo({top:Math.max(0, root.getBoundingClientRect().top + window.scrollY - headerBottom),behavior:'instant'});
    };
    if (document.readyState === 'complete') requestAnimationFrame(revealReferral);
    else window.addEventListener('load', () => requestAnimationFrame(revealReferral), {once:true});
  }
  root.addEventListener('click', event => {
    const link = event.target.closest('a[href^="#"]');
    if (!link || event.button !== 0 || event.ctrlKey || event.metaKey || event.altKey || event.shiftKey) return;
    const key = link.getAttribute('href').slice(1);
    if (!panels.some(panel => panel.id === key)) return;
    event.preventDefault();
    history.pushState(null, '', '#' + key); show();
    const headerBottom = Math.max(0, document.querySelector('header')?.getBoundingClientRect().bottom || 0);
    window.scrollTo({top:Math.max(0, root.getBoundingClientRect().top + window.scrollY - headerBottom),behavior:'instant'});
  });
  // Read only the balance already rendered by YOYO, never earning-rule numbers.
  {
    let balanceFrame;
    const syncBalance = () => {
      const balance = document.querySelector('#clr-unified-widget [class*="_pointsAmount_"]');
      const value = balance?.textContent.trim();
      if (root.dataset.authenticated === 'true' && value && /^[\d\s,.]+$/.test(value)) root.querySelectorAll('[data-tf-profile-points]').forEach(target => {
        if (target.textContent !== value) { target.textContent = value; target.dataset.source = 'yoyo-widget'; }
      });
      const rules = [...document.querySelectorAll('#clr-unified-widget [class*="_rewardDescription_"]')];
      if (rules.length) {
        root.querySelectorAll('[data-tf-earn-rule]').forEach(card => {
          const rule = rules.find(item => item.parentElement?.firstElementChild?.textContent.trim() === card.dataset.tfEarnRule);
          if (card.hidden !== !rule) card.hidden = !rule;
          const match = rule?.textContent.trim().match(/^([\d\s,.]+)\s+(Points?)\s+for\s/i);
          const target = card.querySelector('[data-tf-earn-value]');
          const amount = match ? match[1].trim() + ' ' + match[2] : 'View points';
          if (target && target.textContent !== amount) { target.textContent = amount; target.dataset.source = 'yoyo-widget'; }
        });
        const note = root.querySelector('[data-tf-rewards-source]');
        if (note && note.textContent !== 'Earning amounts loaded from My Rewards. Open a card to check eligibility.') note.textContent = 'Earning amounts loaded from My Rewards. Open a card to check eligibility.';
      }
    };
    new MutationObserver(() => { cancelAnimationFrame(balanceFrame); balanceFrame = requestAnimationFrame(syncBalance); }).observe(document.body, {childList:true,subtree:true,characterData:true});
    syncBalance();
  }
  const orders = [...root.querySelectorAll('[data-tf-order]')];
  let state = 'all';
  const search = root.querySelector('[data-tf-order-search]');
  const searchable = new Map(orders.map(order => [order, order.textContent.toLocaleLowerCase()]));
  root.querySelectorAll('[data-tf-order-count]').forEach(count => count.textContent = String(orders.filter(order => count.dataset.tfOrderCount === 'all' || order.dataset.orderState === count.dataset.tfOrderCount).length));
  function filter() {
    const query = (search?.value || '').trim().toLocaleLowerCase();
    orders.forEach(order => order.hidden = !((state === 'all' || order.dataset.orderState === state) && searchable.get(order).includes(query)));
    const visible = orders.filter(order => !order.hidden).length;
    const summary = root.querySelector('[data-tf-order-summary]'); if (summary) summary.textContent = visible + (visible === 1 ? ' order' : ' orders') + ' on this page';
    const empty = root.querySelector('[data-tf-order-empty]'); if (empty) empty.hidden = visible > 0;
  }
  search?.addEventListener('input', filter);
  root.querySelectorAll('[data-tf-order-filter]').forEach(button => button.addEventListener('click', () => {
    state = button.dataset.tfOrderFilter;
    root.querySelectorAll('[data-tf-order-filter]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
    filter();
  }));
  filter();
  root.querySelector('[data-tf-profile-copy]')?.addEventListener('click', async event => {
    const input = root.querySelector('#TfProfileReferral');
    const button = event.currentTarget, status = root.querySelector('[data-tf-referral-copy-status]');
    if (!input?.value.trim()) return;
    const label = button.textContent;
    try {
      const url = new URL(input.value);
      if (!['http:', 'https:'].includes(url.protocol)) throw new Error('Invalid referral link');
      await navigator.clipboard.writeText(input.value);
      button.textContent = 'Copied';
      if (status) status.textContent = 'Your referral link was copied.';
    } catch {
      input.focus(); input.select(); button.textContent = 'Select and copy';
      if (status) status.textContent = 'Select the link and copy it manually.';
    }
    setTimeout(() => { if (button.isConnected) button.textContent = label; }, 2500);
  });
})();
